import { Select } from 'antd';
import React, { useImperativeHandle, useState } from 'react';

interface IStateTransfer {
  onChange: Function;
  options: any[];
}
export default React.forwardRef((props: IStateTransfer, ref) => {
  const [selectedValue, setSelectedValue] = useState<string | undefined>('');

  const clear = () => {
    setSelectedValue(undefined);
    props.onChange('');
  };

  const _setSelectValue = (ids: string) => {
    setSelectedValue(ids);
  };

  useImperativeHandle(ref, () => ({
    clear,
    _setSelectValue,
  }));

  return (
    <>
      <div>
        <label className="text-grey-5 ml8">应用：</label>
        <Select
          value={selectedValue}
          style={{ minWidth: 100 }}
          bordered={false}
          placeholder="全部"
          allowClear={true}
          onChange={(v: string) => {
            setSelectedValue(v);
            props.onChange(v);
          }}
          options={[
            {
              name: '全部',
              code: '',
            },
            ...(props.options || []),
          ]}
          fieldNames={{
            label: 'name',
            value: 'code',
          }}
        />
      </div>
    </>
  );
});
